var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", {
    attrs: { title: "Recommended Video" },
    scopedSlots: _vm._u([
      {
        key: "button",
        fn: function() {
          return [
            _c("Button", {
              attrs: { variant: "primary", label: "Save" },
              on: { clicked: _vm.save }
            })
          ]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function() {
          return [
            _c("form-item", {
              attrs: { label: "Video Name" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _c(
                        "el-select",
                        {
                          staticClass: "w-full",
                          attrs: {
                            filterable: "",
                            remote: "",
                            "default-first-option": "",
                            placeholder: "Select Video",
                            "remote-method": _vm.searchVideos,
                            loading: _vm.loading
                          },
                          model: {
                            value: _vm.videoId,
                            callback: function($$v) {
                              _vm.videoId = $$v
                            },
                            expression: "videoId"
                          }
                        },
                        _vm._l(_vm.videoList, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17c920c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17c920c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/MissionsVideos/Videos/RecommendedVideos.vue
// module id = null
// module chunks = 